import React, { type PropsWithChildren } from 'react';
import defaultTheme from '@/containers/themes/defaultTheme';
import { fetchWhiteLabel } from '@/features/Company';
import SnackbarProvider from '@/providers/SnackbarProvider';
import { hexToHSL } from '@/shared/lib/utils';
import { esES } from '@mui/material/locale';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { esES as esESDg } from '@mui/x-data-grid';
import { useAppDispatch, useAppSelector } from 'features';
import { getTheme } from 'features/selectors';
import _ from 'lodash';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

// ! Reminder to remove all the sh!t from this file after finishing the migrations
export const AppProviders: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useAppSelector(getTheme);
  const dispatch = useAppDispatch();
  const [newTheme, setNewTheme] = React.useState(() => createTheme(defaultTheme, esES, esESDg));

  React.useEffect(() => {
    const { colors } = theme;
    // * Edit old css vars
    _.forEach(colors, (color, key) => {
      document.documentElement.style.setProperty(`--${key}`, color);
    });

    const newTheme = {
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        primary: {
          ...defaultTheme.palette.primary,
          light: colors['primary-light'],
          main: colors.primary,
          dark: colors['primary-dark'],
        },
        secondary: {
          ...defaultTheme.palette.secondary,
          light: colors['secondary-light'],
          main: colors.secondary,
          dark: colors['secondary-dark'],
        },
      },
    };
    const applyTheme = createTheme(newTheme, esES, esESDg);
    setNewTheme(applyTheme);

    // * Edit TailwindCSS colors. If we want to do more colors in the future, we should do a helper function
    const root = document.documentElement;
    root.style.setProperty('--button-secondary', hexToHSL(colors.secondary));
    root.style.setProperty('--sidebar-accent', hexToHSL(colors.secondary));
  }, [theme]);

  React.useEffect(() => {
    void dispatch(fetchWhiteLabel());
  }, [dispatch]);

  return (
    <MuiThemeProvider theme={newTheme}>
      <StyledThemeProvider theme={newTheme}>
        <SnackbarProvider>
          <div className="app-main">{children}</div>
        </SnackbarProvider>
      </StyledThemeProvider>
    </MuiThemeProvider>
  );
};
